module.exports = __webpack_public_path__ + "static/media/escrever-highlight-en.3c698822.svg";